export const GENERIC_CSV_INTEGRATION_CLASS = 'GenericCsvCustom';
